export default "__VITE_ASSET__4aa39805__"